import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, AlterarFichaAluno } from './types';

export const INITIAL_STATE: AlterarFichaAluno = {
	status: 0,
	data: null,
	dataRequest: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AlterarFichaAluno {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ALTERAR_FICHA_ALUNO_REQUEST: {
				draft.dataRequest = action.payload;
				break;
			}
			case Types.ALTERAR_FICHA_ALUNO_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.data = action.payload.response.data;
				break;
			}
			case Types.ALTERAR_FICHA_ALUNO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ALTERAR_FICHA_ALUNO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.dataRequest = INITIAL_STATE.dataRequest;
				break;
			}
			default:
		}
		return draft;
	});
}
